import axios from 'axios';
import ls from 'local-storage'

// let env


// if (window.location.host === 'localhost:3010') {
//   env = 'dev'
// } else if (window.location.host === 'sand-students.boomwriter.com') {
//   env = 'stage'
// } else if (window.location.host === 'students.boomwriter.com') {
//   env = 'prod'
// }

const studentLogoutAPIUrl = () => {


  return `${ls('chatUrl')}/api/auth/student_logout`
  
  // if (env === 'dev') {
  //   return `http://localhost:3007/api/auth/student_logout`
  // } else if (env === 'stage') {
  //   return `https://sand-schools.boomwriter.com/api/auth/student_logout`
  // } else if (env === 'prod') {
  //   return `https://schools.boomwriter.com/api/auth/student_logout`
  // }
}

export async function postStudentLogout(token) {
  try {
    let response = await axios.post(studentLogoutAPIUrl(ls('env')),{}, { headers: { 'Authorization': token || "" } })
    return response.data.errors ? response.data.errors : window.location.replace(response.data.url)
  } catch (error) {

  }
}

